import React, { Component } from "react";
import * as Constanti from '../../Utils/constants.js';
import '../../style/cards.css';
import '../../style/generic.css';
import moment from "moment";
import ellipse from '../../images/Ellipse-white.png';


class CardDiretta extends Component{
  constructor(props){
    super(props);
    
     this.state = {
            imageUrl: Constanti.url_img_new + this.props.thumbnail
        };
        
}
handleError = () => {
        this.setState({
            imageUrl: Constanti.url_img_new + this.props.thumbnail
        });
    }


  render(){
    return (
      <>
    
       
     <div className="card-small card-small-category">
     <div className="img-card-small" style={{
                backgroundImage: `linear-gradient(#0d162300, #0d1623e6), url(${this.state.imageUrl})`
            }}>
                <img 
                    src={this.state.imageUrl} 
                    onError={this.handleError} 
                    style={{ display: 'none' }} 
                    alt="Thumbnail" 
                />
            </div>
           
       <div className="liveBox-card">
          <div className="content-live flex horizontal justify-center align-center">
          <img src={ellipse} width={6} height={6} alt="" className="imgLive-card"/><span>Live</span>
          </div>
          </div>
      
      <div className="details-card-small">
      <div className="card-info-wrapper"><h4 className="h4">{this.props.title != null && this.props.title.length > 53 ? this.props.title.substring(0,52)+"..." : this.props.title}</h4>
      <div className="video-date">{moment(this.props.data).format('DD/MM/YYYY')}</div>
    </div>
    </div>
	</div>
   </>)
}
}
export default CardDiretta; 





